import { FragmentMeta } from './FragmentMeta';
import { ContentReferenceMeta } from './ContentMeta';
/**
 * Class representing an Content Reference.
 */
export class ContentReference {
    constructor(data) {
        Object.assign(this, data);
        if (data && data._meta) {
            this._meta = new ContentReferenceMeta(data._meta);
        }
        if (data && data.contentType) {
            this.contentType = data.contentType;
        }
    }
    /**
     * Export ContentReference to JSON
     */
    toJSON() {
        const { id } = this;
        const result = {
            id
        };
        if (this._meta) {
            result._meta = this._meta.toJSON();
        }
        if (this.contentType) {
            result.contentType = this.contentType;
        }
        return result;
    }
    /**
     * @hidden
     * Returns true if the provided fragment is an content reference
     * @param fragment
     */
    static isContentReference(fragment) {
        return (FragmentMeta.isFragment(fragment) &&
            fragment._meta.schema ===
                'http://bigcontent.io/cms/schema/v1/core#/definitions/content-reference');
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29udGVudFJlZmVyZW5jZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvY29udGVudC9tb2RlbC9Db250ZW50UmVmZXJlbmNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUM5QyxPQUFPLEVBQUUsb0JBQW9CLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFhckQ7O0dBRUc7QUFDSCxNQUFNLE9BQU8sZ0JBQWdCO0lBSzNCLFlBQVksSUFBOEI7UUFDeEMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7UUFFMUIsSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLEtBQUssRUFBRTtZQUN0QixJQUFJLENBQUMsS0FBSyxHQUFHLElBQUksb0JBQW9CLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDO1NBQ25EO1FBRUQsSUFBSSxJQUFJLElBQUksSUFBSSxDQUFDLFdBQVcsRUFBRTtZQUM1QixJQUFJLENBQUMsV0FBVyxHQUFHLElBQUksQ0FBQyxXQUFXLENBQUM7U0FDckM7SUFDSCxDQUFDO0lBRUQ7O09BRUc7SUFDSCxNQUFNO1FBQ0osTUFBTSxFQUFFLEVBQUUsRUFBRSxHQUFHLElBQUksQ0FBQztRQUNwQixNQUFNLE1BQU0sR0FBNkI7WUFDdkMsRUFBRTtTQUNILENBQUM7UUFFRixJQUFJLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDZCxNQUFNLENBQUMsS0FBSyxHQUFHLElBQUksQ0FBQyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUM7U0FDcEM7UUFFRCxJQUFJLElBQUksQ0FBQyxXQUFXLEVBQUU7WUFDcEIsTUFBTSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUMsV0FBVyxDQUFDO1NBQ3ZDO1FBRUQsT0FBTyxNQUFNLENBQUM7SUFDaEIsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxNQUFNLENBQUMsa0JBQWtCLENBQUMsUUFBYTtRQUM1QyxPQUFPLENBQ0wsWUFBWSxDQUFDLFVBQVUsQ0FBQyxRQUFRLENBQUM7WUFDakMsUUFBUSxDQUFDLEtBQUssQ0FBQyxNQUFNO2dCQUNuQix3RUFBd0UsQ0FDM0UsQ0FBQztJQUNKLENBQUM7Q0FDRiJ9